import { Request } from "../../Servidor/Request";

export class ConstructionTypeRequest {
    private sgeptipoconstrucao: number;
    private nome: string;    

    constructor(sgeptipoconstrucao: number, nome: string) {
        this.sgeptipoconstrucao = sgeptipoconstrucao;
        this.nome = nome;
    }

    /**
     * Getter sgeptipoconstrucao
     * @return {number}
     */
    public getsgeptipoconstrucao(): number {
        return this.sgeptipoconstrucao;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class ConstructionTypeStructRequest {
    private sgeptipoconstrucao: number;

    constructor(sgeptipoconstrucao: number) {
        this.sgeptipoconstrucao = sgeptipoconstrucao;
    }

    /**
     * Getter sgeptipoconstrucao
     * @return {number}
     */
    public getsgeptipoconstrucao(): number {
        return this.sgeptipoconstrucao;
    }
}

export class ConstructionTypeInteractor {
    public fetchSave(request: ConstructionTypeRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("basico/tipo-construcao/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar!"
                    })
                }

                let response = rs.Status == "Sucesso!"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: ConstructionTypeStructRequest): PromiseLike<ConstructionTypeRequest> {
        return new Promise((res, rej) => {
            return new Request().requestPost("basico/tipo-construcao/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar!"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}
